import { IFeatureBox } from "@/api/AppApi/services/home/interfaces/IFeatureBox";
import NextImage from "../../lib/NextImage";
import { truncateString } from "@/utils/functions/functions";

interface Props extends IFeatureBox {
  isOdd?: boolean;
  isMobile?: boolean;
}

const FeatureBox: React.FC<Props> = ({
  icon_url,
  title,
  isOdd = false,
  isMobile = false,
}) => {
  const cn = !isMobile
    ? "feature-box-pc"
    : `feature-box ${isOdd ? "justify-content-center" : ""}`;
  const iconSize = !isMobile ? 36 : 24;
  return (
    <div>
      <div className={cn}>
        <div className="feature-box-image-container">
          <NextImage
            src={icon_url}
            alt=""
            objectFit="fill"
            height={iconSize}
            width={iconSize}
          />
        </div>
        <div className="feature-box-title">{truncateString(title, 27)}</div>
      </div>
    </div>
  );
};

export default FeatureBox;
